// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"22e31210","833":"69acd5bc"}[chunkId] + ".chunk.js";
};